
         <div class="terms-condion-page"  [class.auth-slide-right]="slideAnimation === 'ltr' && isTermsLoaded"
         [class.auth-slide-left]="slideAnimation === 'rtl' && isTermsLoaded">
          <div class="row-align-center center-text-arrow">
            <div class="back-icon-tetx-termsco">
              <button class="back-arrow-btn-black" (click)="onClickOfBack()">
                <img src="assets/icons/back-left-white.svg" alt="back" class="back-arrow-icon" />
              </button>
            </div>
            <div class="ms-heading-termscon">{{"TermsAndConditions" | translate }}</div>
          </div>
            <div class="terms-bg">

         
          <div class="last-updated-text-terms">
            {{ "LastUpdated" | translate }}: {{updatedDate}}
          </div>
         @if (showLoader) {
        <div class="modal-white-spinner">
          <app-spinner></app-spinner>
        </div>
         }
        @if (privacyPolicy) {
        <div class="privacy-policy-content-termscon"  [innerHTML]="privacyPolicy" (scroll)="onScroll($event)"></div>
        }
        @if (!privacyPolicy) {
        <div  class="privacy-policy-content-termscon" (scroll)="onScroll($event)">
          <p><strong>HOLCIM+ APPLICATION TERMS AND CONDITIONS</strong></p>
          <p><strong>Effective Date: 2021-05-19</strong></p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;1. INTRODUCTION</strong></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.1. Holcim Technology Ltd, Grafenauweg 10, 6300
            Zug, Switzerland ( “Holcim Group”) provides to customers the use of the
            application HOLCIM+ (the “Application”), a platform on which customers
            can place orders to buy all types of construction materials and
            products, including components and spare parts relating to construction
            materials, as well as services relating to or in connection with such
            products or existing installations, directly from Holcim Group or other
            third party suppliers (together “Product(s) or Service(s)”).
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.2. The Application allows selected third party
            suppliers, including suppliers being affiliates of Holcim Group (the
            “Supplier(s)”) to offer Products or Services under their own name and
            sell them to customers via Application.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.3. These terms and conditions together with
            all the documents mentioned therein (the "Terms &amp; Conditions" or
            “T&amp;Cs”) govern the use and access to the Application and apply to
            all legal transactions made through the Application including the ones
            with Suppliers. Each Supplier will apply its own terms and conditions to
            the contractual relationship with the Customer, available upon request.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.4. In these T&amp;Cs “you”, “your” or
            “Customer” means the individual, company or entity that has accepted
            these T&amp;Cs and “we”, “us”, “our” means Holcim Group.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.5. You acknowledge that you have read and
            understand these T&amp;Cs.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.6. By using this Application and/or placing an
            order on the Application, you accept these T&amp;Cs and agree to be
            legally bound by its terms.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;1.7. Holcim Group reserves the right to change
            the T&amp;Cs at any time and will give you notice of such amendments via
            an in-Application notification. Your continued access or use of the
            Application constitutes your acceptance of the amended T&amp;Cs. We may
            also ask you to acknowledge your acceptance of the T&amp;Cs through an
            electronic click-through. The latest version of the T&amp;Cs applies at
            any time you are using the Application. These T&amp;Cs may not otherwise
            be amended except through mutual agreement by you and Holcim Group.
            Adverse or conflicting terms of the Customer will not be recognised.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;2. USE AND CHANGE OF THE APPLICATION</strong></p>
          <p>
            By using and/or placing any order on the Application, you agree and
            undertake to the following obligations:&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.1. You represent that you are 18 years of age
            or older and that you have the legal capacity to enter into a binding
            contract, and, if you are an employee or contractor of a Customer, that
            you have the authority to accept these T&amp;Cs on behalf of the
            Customer.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.2. You are responsible for all use of the
            Application by any person who has accessed the Application with your
            login credentials. Holcim Group may deactivate any login credentials for
            any suspected unauthorized use or any misuse of the Application.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.3. You acknowledge and agree that Holcim Group
            is not obliged to provide any support for the Application.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.4. For each order, you will provide an email
            address, a telephone number, the delivery address and the business
            address or your residence so that the Supplier can correctly issue the
            sales invoices. You represent that all the information and data you are
            providing is real, correct and up to date.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.5. You agree that Suppliers can use this
            information to contact you when necessary. You agree that if you do not
            provide Suppliers with all the contact information required, your order
            may not be complete and accept that the Supplier may not be in a
            position to deliver your order.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;2.6. Holcim Group reserves the right, without
            prior notice, to add, delete or change the features or functionality of
            the Application, as we generally make such additions, deletions or
            changes available to our other customers and/or to remove or modify any
            content of the Application.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;3. USE OF THE MY STORE SECTION (ERP)</strong></p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;3.1. If the ”My Store” section of the
            Application is made available to you by Holcim Group, you are free to
            access and use the “My Store” section on a voluntary basis. The use of
            this section is not mandatory for you. The use (or non-use) of the “My
            Store” section will not affect your ability to place orders or make use
            of other functionalities of the Application, the acceptance of the
            order, payment terms or any other terms agreed between Holcim Group and
            you.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;3.2. Any information you upload in the “My
            Store” section of the Application will not be utilized for any other
            purpose than the limited purpose of providing the “My Store” service to
            you. Holcim Group will not share this information with other Customers
            that compete or may potentially compete with you.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;3.3. Holcim Group will not use the information
            you upload in the “My Store” section of the Application to impose any
            minimum or fixed resale price. When purchases done over the Application
            are intended for resale, you are always free to determine your own
            prices in line with applicable laws.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;4. UNACCEPTABLE USE</strong></p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;4.1. Any use of the Application which is in
            breach of applicable laws and regulations, or which is otherwise
            inappropriate or may be damaging to Holcim Group (including the
            LafargeHolcim Group) or any third party, including Holcim Group’s
            customers, business partners or third party suppliers, is unacceptable
            and not permitted.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;4.2. The following is a list of non-exhaustive
            examples of activities which are unacceptable use and not permitted:
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.1. Revealing your account data
            to other third parties or allowing use of your account by others. This
            includes family members, other household members or any other third
            parties.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.2. Accessing any other user
            account, including other customers or third party suppliers, or any
            other data or information within the Application which you are not
            authorized to access.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.3. Any use which violates Holcim
            Group’s or any third party’s Intellectual Property Rights or any law
            relating to Intellectual Property.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.4. Any use which violates
            anti-trust or competition law, anti-bribery and corruption laws.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.5. Procuring or transmitting
            material that violates or is likely to constitute harassment or
            bullying, material that is hostile or abusive to another, or which may
            be defamatory, discriminatory, or intended to offend, material which is
            misleading, or which is of a pornographic nature or illegal.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.6. Using your Application
            account to conduct any unauthorized commercial activity, or making any
            misleading statements in relation to Holcim Group, its staff, customers,
            business partners, products and services or any third party, or in any
            other way which affects the legitimate interests of Holcim Group or
            Suppliers.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2.7. Forwarding, copying, printing
            or otherwise exporting any documents, data, screenshots or other
            information from the Application without Holcim Group’s prior written
            consent.
          </p>
          <p><br /></p>
          <p>
            <strong>&nbsp;&nbsp;5. PLACEMENT AND ASSIGNMENT OF ORDERS; CONCLUSION OF
              CONTRACT</strong>
          </p>
          <p>
            The content of these T&amp;Cs and the information contained in the
            Application is not an offer to sell, but an invitation for you to place
            your order with the Suppliers.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;5.1. Once you have selected the Products or
            Services you want to purchase, you would need to complete the order
            placing process on the Application. The Customer submits a binding offer
            by completing the order placing process from which the Customer can no
            longer withdraw after receipt by the Supplier.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;5.2. Once you have confirmed the order, a pop up
            will appear on your screen confirming that the order has been placed.
            Such message does not represent the acceptance of the order by the
            Supplier. Each order is subject to the acceptance by the Supplier. The
            status of the order can then be consulted on the “Order Details”
            section. The contract between the Customer and the Supplier will be
            concluded once the Supplier has accepted your order (the
            “Acceptance”).&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;5.3. When you place an order on the Application,
            you automatically accept the terms and conditions of the Supplier. Such
            terms and conditions are available upon request to the Supplier.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;5.4. You may not transfer or assign, in any way,
            any order placed in the Application or any of your rights or obligations
            to any third party without the Supplier’s prior written consent.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;5.5. Suppliers have the right, at any time
            during the execution of an order, to transfer, assign, or subcontract
            the order and its delivery or any of their rights or obligations arising
            out of these T&amp;Cs to their affiliates, subcontractors or any other
            third party.&nbsp;
          </p>
          <p><br /></p>
          <p>
            <strong>&nbsp;&nbsp;6. AVAILABILITY OF PRODUCTS AND SERVICES; REJECTION
              ORDERS</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;6.1. Products or Services are available for as
            long as they can be found through the search engine in the Application
            and/or while stocks last.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;6.2. Holcim Group and Suppliers reserve the
            right to remove any Product or Service from the Application at any time.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;6.3. You agree not to claim damages from Holcim
            Group or Suppliers for losses you may incur as a result of removal or
            modification of the Application`s content, Products or Services, or any
            failure to process your order.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;7. PRICES</strong></p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;7.1. Holcim Group and Suppliers reserve the
            right to change prices of Products or Services at any time. The price of
            each Product or Service will be the one displayed on the Application at
            the time you place your order.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;7.2. Although Holcim Group tries to ensure that
            all prices displayed on the Application are correct, errors may occur.
            If Holcim Group or the Supplier discover a price error for any Product
            or Service, Holcim Group or the Supplier will inform you and give you
            the opportunity to reconfirm the order at the correct price or cancel
            it. If Holcim Group or the Supplier cannot contact you, the order will
            be considered cancelled.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;7.3. The prices displayed on the Application are
            net, inclusive of value added tax (VAT), in accordance with the
            applicable laws and regulations.&nbsp;
          </p>
          <p><br /></p>
          <p>
            <strong>&nbsp;&nbsp;8. WARRANTY DISCLAIMER; LIMITATION OF LIABILITY</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.1. Holcim Group does not make any express or
            implied representation or warranty to the Customer regarding the
            Products and Services.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.2. The Customer agrees that it is making use
            of the Application at its own risk and that the Application is being
            provided to the Customer on an "as is" and "as available" basis.
            Accordingly, to the maximum extent permitted by applicable law, Holcim
            Group excludes all express or implied warranties, terms and conditions
            including, but not limited to, implied warranties of accuracy,
            operability, merchantability, fitness for a particular purpose, and
            non-infringement of the Application.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.3. In addition, to the maximum extent
            permitted by applicable law, Holcim Group (including LafargeHolcim
            Group’s affiliates, and its officers, directors, agents and employees)
            are not liable to the Customer or any third party, and the Customer
            agrees not to hold Holcim Group (including LafargeHolcim Group’s
            affiliates, and its officers, directors, agents and employees)
            responsible, for any direct, indirect, consequential losses, damages,
            liabilities, claims and costs (including legal and professional
            adviser’s fees) whether in warranty, tort, negligence, strict liability
            or otherwise arising directly or indirectly out of or in connection with
            these T&amp;Cs, including but not limited to, loss of actual or
            anticipated income, profits, savings or revenues, loss of use, delay or
            non-delivery by Holcim Group or the Supplier of the Products or Services
            or from:
          </p>
          <p>
            &nbsp;&nbsp;a) the content the Customer provides (directly or
            indirectly) using the Application;
          </p>
          <p>
            &nbsp;&nbsp;b) the Customer’s use of or inability to use the
            Application;
          </p>
          <p>
            &nbsp;&nbsp;c) delays or disruptions in the services of the Application;
          </p>
          <p>
            &nbsp;&nbsp;d) viruses or other malicious software obtained by accessing
            or linking to the Application;
          </p>
          <p>
            &nbsp;&nbsp;e) glitches, bugs, errors, or inaccuracies of any kind of
            the Application;
          </p>
          <p>
            &nbsp;&nbsp;f) damage to the Customer’s hardware device from the use of
            the Application;
          </p>
          <p>&nbsp;&nbsp;g) the content, actions, or inactions of third parties;</p>
          <p>
            &nbsp;&nbsp;h) a suspension or other action taken with respect to the
            Customer’s account because of a breach under these T&amp;Cs; or
          </p>
          <p>
            &nbsp;&nbsp;i) the Customer’s loss of doing business as a result of the
            usage of the Application.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.4. To the maximum extent permitted by
            applicable law, Holcim Group’s liability in respect of to any and all
            claims arising out of or in connection with these T&amp;Cs is strictly
            limited to CHF ten thousand (10.000) Swiss francs.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.5. Holcim Group’s liability shall terminate
            upon the expiration of the warranty period according to these T&amp;Cs,
            if any.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;8.6. If the Customer has a dispute with one or
            more users, it releases Holcim Group (including LafargeHolcim Group’s
            affiliates, and its officers, directors, agents and employees) from
            claims, demands and direct or indirect damages of every kind and nature,
            known and unknown, arising out of or in any way connected with such
            disputes. In entering into this release the Customer expressly waives,
            to the maximum extent permitted by applicable law, any protections
            (whether statutory or otherwise) that would otherwise limit the coverage
            of this release.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;9. INDEMNITY</strong></p>
          <p><br /></p>
          <p>
            To the greatest extent permitted by applicable law, you agree to
            indemnify and hold harmless Holcim Group and the Supplier and their
            affiliates, and their officers, directors, agents and employees against
            and from all direct or indirect losses, damages, liabilities, claims and
            costs (including legal and professional adviser’s fees) including
            without limitation losses, damages, liabilities and costs resulting from
            (i) your use or misuse of the Application, including but not limited to
            the content you submit or make available through the Application; (ii)
            claims arising out of or in connection with the sale or purchase of
            Products or Services over the Application; (iii) third party claims
            based on alleged infringements of Intellectual Property Rights; or (iv)
            any breach of these T&amp;Cs by the Customer or its affiliates, and its
            and their officers, directors, agents, employees or subcontractors.
          </p>
          <p><br /></p>
          <p>
            <strong>&nbsp;&nbsp;10. CONTENT; DATA; DATA PROTECTION &amp; PRIVACY;
              PERSONAL DATA PROCESSING&nbsp;</strong>
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.1. For all content or data received by Holcim
            Group, or which Customers deliver into the Application or otherwise
            provides to Holcim Group or Suppliers (the “Customer Content”) the
            Customer grants Holcim Group, a worldwide, non-exclusive, perpetual,
            irrevocable, sublicensable, royalty-free license to access, use, host,
            reproduce, distribute, display, modify and prepare derivative works of
            all Customer Content for purposes of (i) providing the Application to
            customers, (ii) to improve the Application and our services, which
            license extends to any third party assisting Holcim Group and (iii)
            provide Customer Content to Suppliers.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.2. The Customer represents and warrants that,
            for all Customer Content it provides, it owns or otherwise controls all
            necessary rights to do so and to meet its obligations under these
            T&amp;Cs. It represents and warrants that the usage of any such content
            by Holcim Group or Suppliers in compliance with these T&amp;Cs does not
            and will not infringe any Intellectual Property Rights of any third
            party. Holcim Group takes no responsibility and assumes no liability for
            any Customer Content provided by the Customer.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.3. All content, software functionality or
            data made available to you through access or use of the Application or
            otherwise provided by Holcim Group or Suppliers (the “Holcim Group
            Content”), is and will remain the exclusive property of Holcim Group or
            Suppliers and their licensors. You may only use the Holcim Group Content
            for your own internal use in connection with your use of the
            Application.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.4. If Holcim Group provides the Customer with
            information about another user (including Suppliers), the Customer
            agrees that it will use the information only for the purposes of these
            T&amp;Cs. The Customer shall not disclose, sell, rent, or distribute a
            user's information to a third party for purposes unrelated to its use of
            the Application. Additionally, the Customer shall not use user
            information for marketing purposes unless the Customer obtains the
            consent of the specific user owning this information to do so.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.5. Any other messages, information or
            materials you transmit through the Application, such as questions,
            recommendations, suggestions, complaints or other messages (the
            “Feedback”) will be considered as non-confidential and not protected by
            certain Intellectual Property Rights. Holcim Group may, and you hereby
            grant Holcim Group a license to, freely use, disclose, reproduce,
            license, distribute and otherwise commercially exploit such Feedback in
            connection with any software, technology, service, specification or
            other documentation.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.6. Holcim Group’s automated systems scan and
            analyse the contents of every message sent through the Application,
            including messages between the Customers and Suppliers, to detect and
            prevent fraudulent activity or violations of these T&amp;Cs. This
            scanning and analysis may occur before, during, or after the message is
            sent, or while in storage, and may result in the Customers message being
            delayed or withheld. Holcim Group may store message contents, including
            conducting this scanning and analysis.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.7. The Customer represents and warrants to be
            compliant with Swiss Federal Data Protection Act and/or any other local
            Data Privacy Law, as the case may be, is a condition to the business
            relationship between Holcim Group or the Supplier and the Customer.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.8. By accessing the Application and/or by
            accepting these T&amp;Cs you are expressly consenting that Holcim Group
            or Suppliers, as the case may be, may use and process the Personal Data
            as defined at section 10.9 (“Personal Data”), for the following purposes
            (“Permitted Purposes”):
          </p>
          <p>
            &nbsp;&nbsp;1. Providing the Application to you, sharing the Personal
            Data by and between Holcim Group, Suppliers, and third parties assisting
            Holcim Group in managing the Application.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;2. Planning, performing, managing and administering your (or
            a third party's to whom you are related, e.g., your employer)
            contractual business relationship with Holcim Group or Suppliers, e.g.
            by performing transactions and orders of Products or Services,
            processing payments, performing accounting, auditing, billing and
            collection activities, arranging shipments and deliveries, facilitating
            repairs and providing support services or providing you or a third
            party's to whom you are related with other services or things you may
            have requested;
          </p>
          <p>
            &nbsp;&nbsp;3. Maintaining and protecting the security of Holcim
            Group`s, Suppliers’ products, services and websites or other systems,
            preventing and detecting security threats, fraud or other criminal or
            malicious activities;
          </p>
          <p>
            &nbsp;&nbsp;4. Ensuring compliance with legal obligations (such as
            record keeping obligations), compliance screening or recording
            obligations (e.g. under antitrust laws, export laws, trade sanction and
            embargo laws, anti-bribery or corruption laws and internal rules or to
            prevent white-collar or money laundering crimes), which may include
            automated checks of your contact data or other information you provide
            about your identity against applicable sanctioned-party lists and
            contacting you to confirm your identity in case of a potential match or
            recording interaction with you which may be relevant for antitrust
            purposes;
          </p>
          <p>
            &nbsp;&nbsp;5. Sharing your Personal Data with courts, law enforcement
            authorities, regulators or attorneys if legally permitted and necessary
            to comply with a legal obligation or for the establishment, exercise or
            defense of legal claims;
          </p>
          <p>
            &nbsp;&nbsp;6. Solving disputes, enforcing our contractual agreements
            and to establish, exercise or defend legal claims; Instructing service
            providers (so called data processors) within or outside of the
            LafargeHolcim Group, domestically or abroad, e.g. shared service
            centers, to process Personal Data for the Permitted Purposes on our
            behalf. We will retain control over your Personal Data and will use
            appropriate safeguards as required by applicable law to ensure the
            integrity and security of your Personal Data when engaging such service
            providers;
          </p>
          <p>
            &nbsp;&nbsp;7. Communicating with you through the channels made
            available to us to keep you up to date on the latest announcements,
            special offers and other information about Holcim Group and Suppliers’
            products and services (including marketing-related newsletters) as well
            as events and projects;
          </p>
          <p>
            &nbsp;&nbsp;8. Administrating and performing events including customer
            events, customer surveys, marketing campaigns, market analysis,
            sweepstakes, contests or other promotional activities or events;&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;9. Collecting information about you and your preferences to
            create a user profile to personalize and foster the quality of our
            communication and interaction with you (for example, by way of
            newsletter tracking or website analytics); and
          </p>
          <p>
            &nbsp;&nbsp;10. Using your Personal Data by Holcim Group, Suppliers and
            third parties outside the purpose of the Application. In this context,
            the use of your Personal Data means that Holcim Group or Supplier have
            the right to use such data as broadly as possible, to the extent
            permitted by law, which may include using the data for internal
            purposes, marketing purposes, new business opportunities, making the
            data available to third parties free of charge or otherwise subject to a
            fee.&nbsp;&nbsp;&nbsp;
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;10.9. Holcim Group or Suppliers may collect and
            process in particular the following categories of your Personal Data:
          </p>
          <p>
            &nbsp;&nbsp;1. Contact information, such as full name, surname, work
            address, work telephone number, work mobile phone number, work fax
            number and work, email address;
          </p>
          <p>
            &nbsp;&nbsp;2. Payment data, such as data necessary for processing
            payments and fraud prevention, including credit/debit card numbers,
            security code numbers and other related billing information;
          </p>
          <p>
            &nbsp;&nbsp;3. Further business information necessarily processed in a
            project or contractual relationship with Holcim Group or Suppliers or
            voluntarily provided by you, such as orders placed, payments made,
            requests and projects;
          </p>
          <p>
            &nbsp;&nbsp;4. Information collected from publicly available resources,
            integrity data bases and credit agencies; and
          </p>
          <p>
            &nbsp;&nbsp;5. If legally required for compliance purposes: information
            about relevant and significant litigation or other legal proceedings
            against you or a third party related to you and interaction with you
            which may be relevant for antitrust purposes, anti-money laundering or
            anti-bribery and corruption; and
          </p>
          <p>
            &nbsp;&nbsp;6. Company information required for the execution of the
            contractual business relationship with Holcim Group or Suppliers.
          </p>
          <p><br /></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;10.10. Your data protection rights:</p>
          <p>
            &nbsp;&nbsp;a) Subject to certain legal conditions, you may request
            access to, rectification, or restriction of processing of your Personal
            Data. If you make this request repeatedly, we may make an adequate
            charge for this.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;b) For any of the above requests, please send a description
            of your Personal Data concerned stating your name, customer number (or
            other identification number) to the contact details mentioned at section
            13.2. We may require additional proof of identity to protect your
            personal data against unauthorized access. We will carefully consider
            your request and may discuss with you how it can best be fulfilled.
          </p>
          <p>
            &nbsp;&nbsp;c) If you have any concerns about how your Personal Data is
            handled by us or wish to raise a complaint, you can contact us at the
            contact details below to have the matter investigated. If you are not
            satisfied with our response or believe we are processing your Personal
            Data not in accordance with the law you can complain to the competent
            data protection supervisory authority.&nbsp;
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;11. INTELLECTUAL PROPERTY</strong></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.1. All intellectual property rights
            (including but not limited to all intellectual property, including
            patents (and supplementary protection certificates), utility models,
            trade and service marks, logos, trade names, domain names, right in
            designs, copyrights, moral rights, topography rights, rights in
            databases, inventions, trade secrets and know-how) (the “Intellectual
            Property Rights”) to the Application, including but not limited to the
            rights to: (i) continue to develop the Intellectual Property Rights and
            (ii) exploit the Intellectual Property Rights, and all other rights in
            the Application, including all methodologies and systems, embodied
            therein, are and remain the exclusive property of Holcim Group or its
            affiliates.
          </p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;11.2. Nothing in these T&amp;Cs shall:</p>
          <p>
            &nbsp;&nbsp;a) operate to transfer or otherwise grant to the Customer
            any right or interest in Intellectual Property Rights of Holcim Group,
            Suppliers or their affiliates; or
          </p>
          <p>
            &nbsp;&nbsp;b) affect the ownership of Intellectual Property Rights of
            Holcim Group, Suppliers or their affiliates.
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.3. The Customer acknowledges that they have
            no rights in, or to, the Application, including any Intellectual
            Property to it, other than the right to access it in accordance with the
            terms of these T&amp;Cs.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.4. The name "HOLCIM+" and other LafargeHolcim
            Group marks, logos, designs, and phrases that Holcim Group uses in
            connection with the Application are Intellectual Property Rights of
            Holcim Group and/or the LafargeHolcim Group. It may not be used without
            the express written prior permission of Holcim Group.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.5. The Customer shall not acquire, nor claim,
            any right, title or interest in or to any Intellectual Property Rights
            and other rights in the Application or the goodwill attaching to it by
            virtue of these T&amp;Cs or its use of the Intellectual Property Rights
            and other rights in the Application, other than the rights specifically
            granted to it under these T&amp;Cs;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.6. All goodwill arising from use of the
            Application by the Customer shall accrue and belong to Holcim Group or
            its affiliates, and the Customer shall, at Holcim Group’s request,
            promptly execute all documents required by Holcim Group to confirm this.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;11.7. To the extent that any Intellectual
            Property Rights of Holcim Group or its affiliates vest in the Customer
            (including its affiliates, and its and their officers, directors, agents
            and employees) hereby transfers (including by present assignment of
            future rights), or procures that the relevant affiliates, and its and
            their officers, directors, agents and employees shall transfer, at no
            cost, those Intellectual Property Rights (free from all third party
            rights) to Holcim Group or, at Holcim Group’s request, to another member
            of the LafargeHolcim Group.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;12. LINKS FROM THE APPLICATION&nbsp;</strong></p>
          <p><br /></p>
          <p>
            The Application may contain links to other applications or websites of
            third parties. These links are provided for informational purposes only
            and Holcim Group has no control over the content of these applications,
            websites or their respective materials. Accordingly, Holcim Group
            accepts no liability for any loss or damage that may result from the use
            of such links.&nbsp;
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;13. ACCOUNT DELETION, COMPLAINTS AND COMMUNICATION
          </strong></p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;13.1. You may submit Feedback in relation to the
            Application or its content. By using the Application, you agree to
            communicate with Holcim Group or the Supplier primarily through
            electronic means. Holcim Group or the Supplier may therefore contact you
            by email or provide you with information by posting notifications on the
            Application itself.&nbsp;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;13.2. You can ask Holcim Group any questions
            regarding the Application, its use and its content. Suggestions,
            complaints, notices and questions can be submitted at the contact
            details indicated below:&nbsp;
          </p>
          <p>{{'• by email: leadretail-support-hts@lafargeholcim.com'}}&nbsp;</p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;14. CONFIDENTIALITY</strong></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;14.1. The Customer may have access to
            Confidential Information that relates to Holcim Group or Suppliers.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;14.2. The Customer agrees that it shall keep
            Confidential Information of Holcim Group or Suppliers strictly
            confidential and shall safeguard such Confidential Information from
            unauthorised disclosure, reproduction or use.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;14.3. The Customer undertakes to refrain from
            sharing any information on prices or any other Competitively Sensitive
            Information (as defined below) of Holcim Group or Suppliers which has
            been available to the Customer through the Application with third
            parties that are actual or potential competitors of Holcim Group, the
            respective Supplier and/or their affiliates.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;14.4. The Customer shall ensure that they or
            their affiliates and their officers, directors, agents, employees and
            subcontractors:
          </p>
          <p>
            &nbsp;&nbsp;a) are bound to Holcim Group or the Supplier by written
            agreements containing confidentiality obligations at least as stringent
            as those applicable to Supplier under the T&amp;Cs; and
          </p>
          <p>
            &nbsp;&nbsp;b) promptly execute and provide to Holcim Group – upon
            Holcim Group’s request –, any additional agreements containing
            confidentiality obligations as may be required.
          </p>
          <p><br /></p>
          <p>
            “Confidential Information” means any non-public, commercially sensitive
            information or materials belonging to, concerning or in the possession
            or control of Holcim Group, the Supplier and/or their affiliates which
            is provided, disclosed or otherwise made available to the Customer,
            regardless whether directly or through entities or persons acting on the
            Customers behalf; and which (i) is either marked or identified in
            writing as confidential, proprietary or secret or with another
            designation sufficient to give notice of its sensitive nature (e.g. “for
            internal use only “, “confidential”, “highly confidential”), (ii) is of
            a type that a reasonable person would recognize it to be a confidential
            nature, including but not limited to, pricing data or any data that
            would have a bearing on costs, operational data, business plans,
            forecasts, manufacturing and other technical data, business strategies,
            product development details and know-how, or financial information (also
            referred to as “Competitively Sensitive Information”) or (iii) pertains
            to Holcim Group, the Supplier and/or their affiliates’ beneficiaries,
            employees, contracting parties or any other person. Customer Content is
            not Confidential Information.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;15. TERMINATION</strong></p>
          <p><br /></p>
          <p>
            Holcim Group may suspend, disable or terminate the Application or any
            portion of the Application without notice to you, and without liability.
            In the event of a termination, the rights and obligations hereunder will
            terminate immediately, besides any provision hereof required to enforce
            the parties’ rights and obligations hereunder or that by its terms
            continues after such termination, will survive and will continue in
            effect as described therein.
          </p>
          <p><br /></p>
          <p>
            <strong>&nbsp;&nbsp;16. APPLICABLE LAW AND DISPUTE RESOLUTION&nbsp;</strong>
          </p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;16.1. These T&amp;Cs shall be governed by and
            construed in accordance with the substantive laws of Switzerland
            excluding any conflict of law provisions (in particular but not limited
            to the Swiss Federal State on Private International Law (IPRG)) and the
            United Nations Convention on Contracts for the International Sale of
            Goods (CISG). Any disputes arising from or in connection with these
            T&amp;Cs shall be exclusively determined by a court of competent
            jurisdiction in Zurich, Switzerland.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;16.2. If any provision of these T&amp;Cs is held
            to be invalid, illegal, or unenforceable in any jurisdiction due to
            mandatory local law to protect consumers which cannot be waived or
            limited by contract, i) the validity, binding effect or enforceability
            of such provision shall not in any way be affected in respect of any
            other jurisdiction and the validity, binding effect and enforceability
            of the remaining provisions shall remain in full force and effect and
            ii) such provision shall be replaced by one or more valid and
            enforceable provisions according to mandatory local law approximating
            the original provision as closely as possible.
          </p>
          <p><br /></p>
          <p><strong>&nbsp;&nbsp;17. MISCELLANEOUS</strong></p>
          <p><br /></p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;17.1. Except as otherwise provided in these
            T&amp;Cs, the Customer may not assign, transfer, subcontract, sublicense
            or otherwise dispose of the T&amp;Cs or any of its rights or obligations
            under these T&amp;Cs, without the prior written consent of Holcim Group
            or Suppliers.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;17.2. These T&amp;Cs sets out the entire
            agreement between the Customer and Holcim Group in respect of the
            subject matter of these T&amp;Cs and supersedes any previous draft,
            agreement, arrangement or understanding, whether in writing or not,
            relating to its subject matter.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;17.3. In the event that any provision of these
            T&amp;Cs is determined to be partially or totally invalid or illegal or
            unenforceable, the remainder of these T&amp;Cs shall survive and the
            validity, binding effect and enforceability of the remaining provisions
            of the T&amp;Cs shall not be affected in any manner.
          </p>
          <p><br /></p>
          <p>
            Nothing under these T&amp;Cs will constitute, create, give effect to or
            otherwise recognize a joint venture, partnership or business entity of
            any kind, nor will anything hereunder constitute either party as the
            agent or representative of the other.
          </p>
        </div>
        }
      </div>
       